// extracted by mini-css-extract-plugin
export default {"quizMakerContainer":"QuestionsBank_quizMakerContainer__bpv3E"};